(function ($) {
  "use strict";

  /* Navbar Toggler
     ========================================================================== */

  $(document).on("click", ".navbar-toggler", function (e) {
    e.preventDefault();
    $("body").toggleClass("site-navbar-open");
  });

  /* Sub Menu Toggler
     ========================================================================== */

  $(document).on("click", ".sub-menu-toggler", function (e) {
    e.preventDefault();
    $(this).parent().parent().toggleClass("sub-menu-open");
  });

  /* Menu Item Disabled
     ========================================================================== */

  $(".menu-item-disabled > a").click(function (e) {
    e.preventDefault();
  });

  /* Sidebar Search
     ========================================================================== */

  $(window).on("load scroll resize", function () {
    if ($(window).width() < 1024) {
      $(".post-type-archive-funds #sidebarSearch").detach().prependTo(".funds-header");
    } else {
      $(".post-type-archive-funds #sidebarSearch").detach().prependTo(".site-sidebar");
    }
  });

  /* Site Loaded
     ========================================================================== */

  $(window).on("load", function () {
    $(".site").addClass("site-loaded");
  });

  /* Sticky Navigation
     ========================================================================== */

  $(window).on("load scroll resize", function () {
    var stickyWrapper = $("#page");
    var stickyElement = $("#header");
    var stickyOffsetPostion = $("#header").innerHeight();
    var stickyClass = "sticky";
    var stickyScrolledClass = "sticky-scrolled";

    if ($(window).scrollTop() > stickyOffsetPostion) {
      stickyWrapper.addClass(stickyClass);
      stickyElement.addClass(stickyClass);
    } else {
      stickyWrapper.removeClass(stickyClass);
      stickyElement.removeClass(stickyClass);
    }

    if ($(window).scrollTop() > stickyOffsetPostion + 1) {
      stickyElement.addClass(stickyScrolledClass);
    } else {
      stickyElement.removeClass(stickyScrolledClass);
    }
  });


  // Switch mobile navigation menu when scrolling page

  $(window).on('activate.bs.scrollspy', function () {
    $('#anchor-nav-menu-mobile').val($('#anchor-nav-menu .active').attr('href'));
  });


  /* Search Toggle Focus
     ========================================================================== */

  $(document).on("click", "#header .search-toggler", function (e) {
    e.preventDefault();
    $("#header .search-field").focus();
  });

  /* Telephone Links
     ========================================================================== */

  $(".tel[data-phone], .tel .value[data-phone]").each(function () {
    var tel = $(this);
    var link = $("<a/>");

    link.html(tel.html());
    link.attr("href", "tel:" + tel.data("phone"));
    link.attr("class", tel.attr("class"));

    tel.replaceWith(link);
  });

  /* Accordion
     ========================================================================== */

  var accordion = "[data-accordion]";
  var accordionHeader = "[data-accordion-header]";
  var accordionContent = "[data-accordion-content]";
  var accordionActiveClass = "active";

  $(accordion).each(function () {
    var accordionInit = $(this).data('accordion-init');

    $(this)
      .find(accordionContent).hide().end()
      .find(accordionHeader + ":eq(" + accordionInit + ")").addClass(accordionActiveClass).end()
      .find(accordionContent + ":eq(" + accordionInit + ")").show().end();
  });

  $(accordion).on("click", accordionHeader, function (e) {
    var self = $(this);
    var accordionBody = self.closest(accordion);

    if (accordionBody.is('[data-accordion-toggleable]')) {
      self.toggleClass(accordionActiveClass)
        .next(accordionContent).slideToggle(function () {
          if ($(window).width() < 768) {
            $(document).scrollTop(self.offset().top);
          }
        }).end();
    }
    else if (!self.hasClass(accordionActiveClass)) {
      accordionBody
        .find(accordionHeader).removeClass(accordionActiveClass).end()
        .find(accordionContent).slideUp().end();

      self.addClass(accordionActiveClass)
        .next(accordionContent).slideDown(function () {
          if ($(window).width() < 768) {
            $(document).scrollTop(self.offset().top);
          }
        }).end();
    }
    e.preventDefault();
  });

  /* Video Overlay
     ========================================================================== */

  $(".video-overlay[data-video-id]").one("click", function () {
    $(this).html("<iframe src=\"https://www.youtube.com/embed/" + $(this).data("video-id") + "?enablejsapi=1&autoplay=1&rel=0\" allowfullscreen></iframe>");
  });

  /* Slick Slider
     ========================================================================== */

  $("[data-slick]").slick();

  /* Fancybox
     ========================================================================== */

  // Gallery

  $(".gallery-thumbnail a").fancybox({
    margin: [44, 0],
    gutter: 32,
    caption: function () {
      return $(this).parent().parent().find("figcaption").html();
    }
  });

  /* Tabs
   ========================================================================== */

  // Scroll to tab content when tab is selected (mobile and tablet)
  $('.section-tabs .tabset .nav-link').on('shown.bs.tab', function () {
    if ($(window).width() <= 1023) {
      location.href = $(this).attr("href");
    }
  });

  // Switch vertical tabs using mobile select menu
  $('.section-vertical-tabs .tabset-select-menu').on('change', function () {
    $(this).closest('.tabset').find('#' + $(this).val()).tab('show');
  });


  /* Flexible template parallax background images
   ========================================================================== */

  const simpleParallax = require('simple-parallax-js');
  var parallaxBgImages = document.querySelectorAll('.parallax-bg-image');
  new simpleParallax(parallaxBgImages);


  /* Donate modal
   ========================================================================== */

  //  Disable 'Review Donation' button until amount entered
  $('.donate-form input').on('keyup', function () {
    $('.donate-form button').removeAttr('disabled');
  });


  /* Newsletter Form
   ========================================================================== */

  // When visitor arrives via anchor link
  $(window).on('load hashchange', function () {
    let hash = window.location.hash;

    // Focus the First Name field
    if (hash == '#newsletter')
      $('#newsletter #input_1_1').trigger('focus');
  });

  /* Mobile 'Give Now' header button
   ========================================================================== */
  // Single click opens dropdown by default; double-click opens page

  $('.navbar-area-1 #btn-give1').on('dblclick', function () {
    window.location = this.href;
  });


}(jQuery));
